import React from "react";
import { Factor } from "../factor";
import { Factor as FactorType, UseRisksContext } from "../useRisks";
import './factors.scss';

export const Factors: React.FC<{ factors: FactorType[], type: string }> = function ({ factors, type }) {
  const {
    openDetails
  } = UseRisksContext()

  return <div className="ui-factors">
    <div className="ui-factors__title">
      Top Contributing Factors
    </div>
    <div className="ui-factors__list">
      {
        factors && factors.map(
          (factor, index) => (
            <div className="ui-factors__list__item">
              <div className="ui-factors__list__item__number">
                {index + 1}.
              </div>
              <Factor key={index} type={type} factor={factor} openDetails={openDetails} />
            </div>
          )
        )
      }
    </div>
  </div>
};
